<template>
  <v-row no-gutters id="snippetContent">
    <v-col cols="5" xl="5" lg="6" md="12">
      <InputsTree :inputs="snippetInputs" :data="data" />
    </v-col>
    <v-col cols="7" xl="7" lg="6" md="12">
      <h4>{{ $t("strings.code-editor-module") }}</h4>
      <h6>{{ $t("strings.code-ediotr-tip") }}</h6>
      <v-sheet
        id="editorSection"
        class="overflow-y-hidden overflow-x-hidden pt-4"
        :max-height="data.parentContentHeight"
      >
        <CodeEditor
          :snippetContentHeight="snippetContentHeightComputed"
          :snippetSources="snippetSources"
        />
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import {
  provide,
  reactive,
  toRefs,
  watch,
  computed,
  onMounted,
  ref,
  nextTick,
  onUnmounted,
  defineAsyncComponent,
} from "vue";
import InputsTree from "../blocks/static/InputsListTree.vue";

export default {
  name: "OperatorCreateObject",
  props: ["target", "data", "operatorInputs"],
  emits: ["updateFormData"],
  components: {
    InputsTree,
    CodeEditor: defineAsyncComponent(() => import("../blocks/dynamic/CodeEditor.vue")),
  },
  setup(props, { emit }) {
    //Creates a deep copy, unlinked of target.userData
    const formData = reactive(
      JSON.parse(JSON.stringify(props.target.userData)) || {},
    );
    provide("formData", formData);

    const snippetInputs = computed(() => {
      return props.operatorInputs;
    });

    //Creates a sources array objects for the snippet
    const snippetSources = computed(() => {
      const orderedIds = props.target.userData.inputs;
      let sources = snippetInputs.value.map((inputObject) => {
        return {
          id: inputObject.id,
          name: inputObject.userData?.label || inputObject.userData?.name,
          type: inputObject.operatorId,
          content: inputObject.userData?.contentType || "",
        };
      });
      //Order the sources based on the order given by the array of inputs connected to the operator
      sources = sources.sort((a, b) => {
        return orderedIds.indexOf(a.id) - orderedIds.indexOf(b.id);
      });
      return sources;
    });

    const snippetContentHeightComputed = computed(() => {
      return snippetContentHeight.value;
    });

    // Create a new ResizeObserver to observe the #inputListTree-div height
    let snippetContentHeight = ref(null);
    let div = ref(null); //this will be the div observed by ResizeObserver
    let observer = new ResizeObserver((entries) => {
      setTimeout(() => {
        for (let entry of entries) {
          snippetContentHeight.value = entry.contentRect.height;
        }
      }, 500);
    });

    onMounted(async () => {
      await nextTick();
      snippetContentHeight.value =
        document.getElementById("inputListTree")?.offsetHeight; //get the tree inputs section height
      div.value = document.getElementById("inputListTree");
      observer.observe(div.value); //activate the ResizeObserver with current div
    });

    onUnmounted(() => {
      observer.unobserve(div.value);
      observer.disconnect();
    });

    watch(
      () => props.snippetContentHeight,
      (newValue) => {
        snippetContentHeight.value = newValue;
      },
      { immediate: true },
    );

    //Assign once snippet sources to formData/userData
    let isAssigned = false;
    watch(snippetSources, (newSnippetSources) => {
      if (newSnippetSources.length > 0 && !isAssigned) {
        formData.sources = newSnippetSources;
        isAssigned = true;
      }
    });

    watch(
      formData,
      (newFormData) => {
        emit("updateFormData", newFormData);
      },
      { deep: true },
    );

    return {
      snippetInputs,
      formData,
      ...toRefs(formData),
      snippetContentHeightComputed,
      snippetSources,
    };
  },
};
</script>
